export const createConversationRules = (inputs) => {
    return {
        title: {
            errors: [],
            value: inputs.title,
            isValid: null,
            validations: {
                required: "Conversation title is required",
                maxLength: {
                    value: 100,
                    error: "Title cannot be more than 100 characters"
                }
            }
        }
    }
}; 